import ConfirmModal from "./confirm-modal.component";

export default ConfirmModal;
